<!--
* @description  参数1
* @fileName  quote
* @author userName
* @date 2024-01-29 15:31:14
!-->
<template>
  <div id="quote" class="quote">
    <div class="list-card">
      <!-- 门起运 -->
      <div v-if="data.ServiceType == 1 || data.ServiceType == 2">
        <div class="card-title">
          <span>{{ `${data.startCityNameEn},${data.startCityZipCode}>${data.shipPortCode}` }}</span>
        </div>
        <div class="card-table">
          <table>
            <tr>
              <td>Fee code</td>
              <td>Fee name</td>
              <td>Comment</td>
              <td>Units</td>
              <td>Units price</td>
              <td>Amount</td>
            </tr>
            <tr v-if="data.pickupAmount > 0">
              <td>PICKUP</td>
              <td>Pickup Fee</td>
              <td>Pickup Fee</td>
              <td>1</td>
              <td>US ${{ data.pickupAmount }}</td>
              <td>US ${{ data.pickupAmount }}</td>
            </tr>
            <tr v-if="data.startLiftgateAmount > 0">
              <td>LIFT</td>
              <td>Lift Gate Charge</td>
              <td>Flat Fee</td>
              <td>1</td>
              <td>US ${{ data.startLiftgateAmount }}</td>
              <td>US ${{ data.startLiftgateAmount }}</td>
            </tr>
          </table>
        </div>
        <div class="card-subtotal">
          <span>Subtotal: US ${{ pickupFeeSum() }}</span>
        </div>
      </div>
      <div v-if="originFeeList()">
        <div class="card-title">
          <span>Origin charges</span>
        </div>
        <div class="card-table">
          <table>
            <tr>
              <td>Fee code</td>
              <td>Fee name</td>
              <td>Comment</td>
              <td>Units</td>
              <td>Units price</td>
              <td>Amount</td>
            </tr>
            <tr v-for="feeItem in originFeeList()" :key="feeItem">
              <td>{{ feeItem.FeeNameEn }}</td>
              <td>{{ feeItem.FeeNameEn }}</td>
              <td>{{ feeItem.FeeNameEn }}</td>
              <td>{{ feeItem.Quanlity }}</td>
              <td>US ${{ feeItem.UnitPrice }}</td>
              <td>US ${{ feeItem.Amount }}</td>
            </tr>
          </table>
        </div>
        <div class="card-subtotal">
          <span>Subtotal: US ${{ originSumFee() }}</span>
        </div>
      </div>
      <!-- 空运运费 -->
      <div>
        <div class="card-title">
          <span>{{ data.shipPortCode }}-{{ data.destPortCode }}</span>
        </div>
        <div class="card-table">
          <table>
            <tr>
              <td>Fee code</td>
              <td>Fee name</td>
              <td>Comment</td>
              <td>Units</td>
              <td>Units price</td>
              <td>Amount</td>
            </tr>
            <tr>
              <td>Freight - Sea</td>
              <td>Freight - Sea</td>
              <td>Per KG Rate</td>
              <td>{{ data.chargeWeight }}</td>
              <td>US ${{ data.costPrice }}</td>
              <td>US ${{ data.costAmount }}</td>
            </tr>
          </table>
        </div>
        <div class="card-subtotal">
          <span>Subtotal: US ${{ data.costAmount }}</span>
        </div>


      </div>
      <!-- 目的地费用 -->
      <div v-if="filteredDestFeeList()">
        <div class="card-title">
          <span>Destination charges</span>
        </div>
        <div class="card-table">
          <table>
            <tr>
              <td>Fee code</td>
              <td>Fee name</td>
              <td>Comment</td>
              <td>Units</td>
              <td>Units price</td>
              <td>Amount</td>
            </tr>
            <tr v-for="(destFeeItem, destFeeIndex) in filteredDestFeeList()" :key="destFeeIndex">
              <td>{{ destFeeItem.FeeNameEn }}</td>
              <td>{{ destFeeItem.FeeNameEn }}</td>
              <td>{{ destFeeItem.FeeNameEn }}</td>
              <td>{{ destFeeItem.Quanlity }}</td>
              <td>US ${{ destFeeItem.UnitPrice }}</td>
              <td>US ${{ destFeeItem.Amount }}</td>
            </tr>
          </table>
        </div>
        <div class="card-subtotal">
          <span>Subtotal: US ${{ destFeeSum() }}</span>
        </div>
      </div>
      <div v-if="(data.ServiceType == 1 || data.ServiceType == 4)">
        <div class="card-title">
          <span>{{ `${data.destPortCode}>${data.destCityNameEn},${data.destCityZipCode}`
            }}</span>
        </div>
        <div class="card-table">
          <table>
            <tr>
              <td>Fee code</td>
              <td>Fee name</td>
              <td>Comment</td>
              <td>Units</td>
              <td>Units price</td>
              <td>Amount</td>
            </tr>
            <tr v-if="data.deliveryAmount > 0">
              <td>AIR DELIVERY FREIGHT</td>
              <td>AIR DELIVERY FREIGHT</td>
              <td>AIR DELIVERY FREIGHT</td>
              <td>1</td>
              <td>US ${{ data.deliveryAmount }}</td>
              <td>US ${{ data.deliveryAmount }}</td>
            </tr>
            <tr v-if="data.destLiftgateAmount > 0">
              <td>LIFT</td>
              <td>Lift Gate Charge</td>
              <td>Flat Fee</td>
              <td>1</td>
              <td>US ${{ data.destLiftgateAmount }}</td>
              <td>US ${{ data.destLiftgateAmount }}</td>
            </tr>
          </table>
        </div>
        <div class="card-subtotal">
          <span>Subtotal: US ${{ destFeeUesdSum() }}</span>
        </div>
      </div>
      <div v-if="data.isCustomsBrokerage">
        <div class="card-title">
          <span>Customs Brokerage</span>
        </div>
        <div class="card-table">
          <table>
            <tr>
              <td>Fee code</td>
              <td>Comment</td>
              <td>Amount</td>
            </tr>
            <tr v-for="( item, index ) in usedDestFeeList() " :key="index">
              <td>{{ item.FeeNameEn }}
              </td>
              <td>{{ item.FeeNameEn }}</td>
              <td>US ${{ item.Amount }}</td>
            </tr>
            <tr v-if="data.bondAmount > 0">
              <td>{{ data.bondType === 1 ? 'Single Entry Bond(based on goods value of USD' + data.goodsValue + ')' :
        'Annual bond' }}
              </td>
              <td>-</td>
              <td>US ${{ data.bondAmount }}</td>
            </tr>
          </table>
        </div>
        <div class="card-subtotal">
          <span>Subtotal: US ${{ customsFeeSum() }}</span>
        </div>
      </div>
      <!-- 保险 -->
      <div v-if="data.isrInsurance">
        <div class="card-title">
          <span>Insurance</span>
        </div>
        <div class="card-table">
          <table>
            <tr>
              <td>Fee code</td>
              <td>Comment</td>
              <td>Amount</td>
            </tr>
            <tr>
              <td>Insurance (based on goods value of USD {{ data.goodsValue }})</td>
              <td>-</td>
              <td>US ${{ data.insuranceAmount }}</td>
            </tr>
          </table>
        </div>
        <div class="card-subtotal">
          <span>Subtotal: US ${{ data.insuranceAmount }}</span>
        </div>
      </div>
      <div class="card-total">
        <span>Total: US ${{ data.totalAmount }}</span>
      </div>
      <div class="card-remarks">
        <p>LCL Service</p>
        <slot v-for="item in data.channelDetail">
          <p>{{ item.moduleNameEn }}:</p>
          <span>
            {{ item.contentEn }}
          </span>
        </slot>

      </div>
    </div>

  </div>
  </div>
</template>

<script>
export default {
  name: 'Quote',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data () {
    return {
      data: {},
    }
  },
  computed: {
    // 计算属性

  },
  watch: {
    // 监测变化
  },
  created () {
    // 实例被创建之后执行代码
  },
  mounted () {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    init (data) {
      this.data = data
    },
    filteredDestFeeList () {
      if (this.data.feeList == null) return;
      return this.data.feeList.filter(item => item.FeeType == 3);
    },
    destFeeSum () {
      var list = this.filteredDestFeeList();
      if (list) {
        return list.reduce((accumulator, item) => accumulator + item.Amount, 0).toFixed(3)
      } else {
        return 0
      }
    },
    usedDestFeeList () {
      if (this.data.feeList == null) return;
      return this.data.feeList.filter(fee => fee.FeeType == 4)
    },
    destFeeUesdSum () {
      return (parseFloat(this.data.deliveryAmount) + parseFloat(this.data.destLiftgateAmount)).toFixed(3)
    },
    customsFeeSum () {
      var customsFee = 0
      var customsFeeList = this.usedDestFeeList();
      if (customsFeeList) {
        customsFee = parseFloat(customsFeeList.reduce((accumulator, customsFee) => accumulator +
          customsFee.Amount, 0))
      }
      return (parseFloat(this.data.bondAmount) + customsFee).toFixed(3)
    },
    originFeeList () {
      if (this.data.feeList == null) return;
      return this.data.feeList.filter(fee => fee.FeeType == 2)
    },
    originSumFee () {
      var list = this.originFeeList();
      if (list) {
        return list.reduce((accumulator, customsFee) => accumulator + customsFee.Amount, 0).toFixed(3)
      } else {
        return 0
      }
    },
    pickupFeeSum () {
      var amount = 0;
      if (this.data.startLiftgateAmoun > 0) {
        amount = parseFloat(this.data.startLiftgateAmount)
      }
      if (this.data.pickupAmount > 0) {
        amount += parseFloat(this.data.pickupAmount);
      }
      return amount;
    }
  }
}
</script>
<style scoped lang='scss'>
.quote {
  width: 1152px;
  height: auto;
  background: #FFFFFF;
  border-radius: 8px;
  margin-top: 16px;
  padding: 24px;

  .list-card {
    .card-title {
      width: 100%;
      height: 40px;
      background: rgba(170, 170, 170, 0.08);
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 40px;
      text-align: left;

      span {
        margin-left: 16px;
      }
    }

    .card-table {
      table {
        width: 100%;
        border-collapse: collapse;
        text-align: left;
        padding: 0 8px;

        tr:nth-of-type(1) {
          td {
            font-size: 13px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 550;
            color: #333333;
          }
        }

        tr {
          height: 40px;

          td {
            border-bottom: 1px solid rgba(170, 170, 170, 0.24);
            font-size: 13px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #333333;
            padding: 0 16px;
          }

          td:last-child {
            text-align: right;
          }
        }
      }
    }

    .card-subtotal {
      font-size: 14px;
      font-family: D-DINExp, D-DINExp;
      font-weight: bold;
      color: #333333;
      height: 40px;
      line-height: 40px;
      text-align: right;
      padding-right: 16px;
    }

    .card-total {
      height: 40px;
      line-height: 40px;
      text-align: right;
      background: rgba(2, 127, 252, 0.08);
      font-size: 16px;
      font-family: D-DINExp, D-DINExp;
      font-weight: bold;
      color: #333333;
      padding-right: 16px;
    }

    .card-remarks {
      width: 100%;
      height: 161px;
      background: rgba(0, 0, 0, 0.02);
      border-radius: 8px;
      margin: 16px 0;
      text-align: left;
      overflow-y: scroll;

      p {
        padding: 4px 8px;
        margin: 0;
      }

      span {
        padding: 0 8px;
        display: block;
      }
    }
  }
}
</style>
